//程序调用地址
let dbUrl = "http://127.0.0.1:31899/callProvider";
// let dbUrl = "http://192.168.123.206:31899/callProvider";
//程序环境 true  开发环境，false 生产环境
const dev = false;
//当前环境地图坐标系
let MapCoordinateSystemType=""
//文件上传路径
//普通文件下载路径
let FIEL_UPLOAD="";
let FIEL_DOWNLOAD='';
//分析报告下载路径
let FXBG_DOWNLOAD='';
//gis地图地址
let MAP_URL="";
//证据图片，地图定位
let PIC_HIGHT_LIGHT_URL="";
let PIC_POSITION_URL="";
let PIC_DRONE_URL="";
let PIC_DRONE_HIGHT_LIGHT_URL="";
let DEFAULT_USER="";
let ANTU_PUSH_URL="";
let ANTU_PUSH_APIKEY="";
let ZYDJ_URL="";
let JFJJZ_URL="";
let ZYDJ_LEGAL_URL="";
let KJFX_URL="";
let WSBL_URL="";
//询问省政务平台是否登录的URL
//let CHECK_LOGIN_URL="https://sfrz.shaanxi.gov.cn/sysauthserver/authorize?authCheck=true&needAuth=true&client_id=SN000000710&redirect_uri=http://113.200.222.157:8080/xmjcpt/#/ZydjMain";
if (dev){
  //开发环境
  //调用多测合一上传、下载逻辑
  FIEL_UPLOAD="http://192.165.122.223:21907/testfileUpload";
  FIEL_DOWNLOAD="http://192.165.122.223:21907/testdownload";
  FXBG_DOWNLOAD="http://192.165.122.223:21907/testdownload";
  MAP_URL="http://192.168.123.206:8080/onemapV6.0/main.html?" + btoa(encodeURIComponent("loginName=admin&psw=a1234567.&ua=1&full=1"));
  PIC_HIGHT_LIGHT_URL="http://192.168.123.206:8080/onemapV5.0/images/zhdc/Rjt.png";
  PIC_POSITION_URL="http://192.168.123.206:8080/onemapV5.0/images/zhdc/Yjt.png";
  PIC_DRONE_URL="http://192.168.123.206:8080/onemapV5.0/images/Drone/Drone.png";
  PIC_DRONE_HIGHT_LIGHT_URL="http://192.168.123.206:8080/onemapV5.0/images/Drone/DroneHighlight.png";
  DEFAULT_USER="http://192.168.123.206:8080/onemapV5.0/images/zhdc/user.png";
  ANTU_PUSH_URL="http://192.168.123.206:8080/AntuPush";
  ANTU_PUSH_APIKEY="8457293FEF1547468D62DA838B10F10E";
  MapCoordinateSystemType="4326";
  ZYDJ_URL = "http://127.0.0.1:8080/#/ZydjMain";
  WSBL_URL = "http://127.0.0.1:8080/#/ZydjWsbl";
  JFJJZ_URL = "http://127.0.0.1:8080/#/JfjjzMain";
  ZYDJ_LEGAL_URL = "http://127.0.0.1:8080/#/ZydjLegalMain";
  KJFX_URL = "http://127.0.0.1:8080/#/KjfxPage";
} else{
  //正式环境-外网
  //调用多测合一上传、下载逻辑
  // dbUrl = "http://113.200.222.157:8889/MobileBuilder/callProvider";
  dbUrl = "http://111.21.167.150:21907/callProvider";
  FIEL_UPLOAD="http://111.21.167.150:21907/testfileUpload";
  FIEL_DOWNLOAD="http://111.21.167.150:21907/testdownload";
  // FXBG_DOWNLOAD="http://111.21.167.150:21907/download";
  FXBG_DOWNLOAD="https://www.ylzygh.com/pdfweb/download";//加密映射
  MAP_URL="http://111.21.167.150:6003/onemapV5.0/main.html?config=config-zhdc.xml&"+btoa(encodeURIComponent("loginName=ys&psw=a1234567&ua=1&full=1"));
  // MAP_URL="http://111.21.167.150:6003/onemapV5.0/main.html?config=config4326.xml&"+btoa(encodeURIComponent("loginName=ys&psw=a1234567.&ua=1&full=1"));
  PIC_HIGHT_LIGHT_URL="http://111.21.167.150:6003/onemapV5.0/images/zhdc/Rjt.png";
  PIC_POSITION_URL="http://111.21.167.150:6003/onemapV5.0/images/zhdc/Yjt.png";
  PIC_DRONE_URL="http://111.21.167.150:6003/onemapV5.0/images/Drone/Drone.png";
  PIC_DRONE_HIGHT_LIGHT_URL="http://111.21.167.150:6003/onemapV5.0/images/Drone/DroneHighlight.png";
  DEFAULT_USER="http://111.21.167.150:6003/onemapV5.0/images/zhdc/user.png";
  ANTU_PUSH_URL="http://111.21.202.218:9888/AntuPush";
  ANTU_PUSH_APIKEY="E5F4B6D05EA14C33BB097C768F3C7EB2";
  MapCoordinateSystemType="4326";
  ZYDJ_URL = "http://113.200.222.157:8080/xmjcpt/#/ZydjMain";
  WSBL_URL = "http://113.200.222.157:8080/xmjcpt/#/ZydjWsbl";
  JFJJZ_URL = "http://113.200.222.157:8080/xmjcpt/#/JfjjzMain";
  ZYDJ_LEGAL_URL = "http://113.200.222.157:8080/xmjcpt/#/ZydjLegalMain";
  KJFX_URL = "http://113.200.222.157:8080/xmjcpt/#/KjfxPage";
}

const API = {
  "MapCoordinateSystemType":MapCoordinateSystemType,
  "zydjUrl":ZYDJ_URL,
  "wsblUrl":WSBL_URL,
  "jfjjzUrl":JFJJZ_URL,
  "zydjLegalUrl":ZYDJ_LEGAL_URL,
  "kjfxUrl":KJFX_URL,
  "ajaxPath":dbUrl,
  "fileUpload":FIEL_UPLOAD,
  "fileDownLoad":FIEL_DOWNLOAD,
  "fxbgDownLoad":FXBG_DOWNLOAD,
  "mapUrl":MAP_URL,
  "picHightLightUrl":PIC_HIGHT_LIGHT_URL,
  "picPositionUrl":PIC_POSITION_URL,
  "DronePic":PIC_DRONE_URL,
  "DroneHightLightPic":PIC_DRONE_HIGHT_LIGHT_URL,
  "defaultUser":DEFAULT_USER,
  "pushUrl":ANTU_PUSH_URL,
  "pushKey":ANTU_PUSH_APIKEY,
  "superviseCommonInfo":"antu.supervise.provider.CommonInfo.CommonInfoProvider",
  "GisProvider":"antu.gis.provider.task.TaskProvider",
  "kjfxUserProvider":"antu.WwXmJcpt.provider.userProvider",
  "KjfxCommonProvider":"antu.WwXmJcpt.provider.common.CommonProvider",
  "KjfxProvider":"antu.WwXmJcpt.provider.kjfx.KjfxProvider",
  "ZydjProvider":"antu.WwXmJcpt.provider.zydj.ZydjSdghProvider",
  "YwxtProvider":"antu.WwXmJcpt.provider.ywxt.YwxtProvider",
};

export default API;



// WEBPACK FOOTER //
// ./src/api/ApiConfig.js